import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useOffCanvasStore } from '../store';
import { JxtWorkplaceCalendarContainer } from '../components';
import { IOffCanvasContent } from './offCanvasContent.types';

// The generic "one-off panel" kind: a small typed slot for content that isn't a full state
// machine of its own (unlike booking/floor/resource) - currently only the monthly workplace
// calendar opened from Home and Colleagues. The store never holds ReactNode: this hook is the
// only place that turns the stored data (a range + a callback) into the actual component.
export const useWorkplaceCalendarOffCanvasContent = (): IOffCanvasContent => {
  const { t } = useTranslation();
  const payload = useOffCanvasStore((state) => state.workplaceCalendar);
  const close = useOffCanvasStore((state) => state.close);

  // Memoized like the other three content hooks: without this, `children` is a brand new element
  // every render (not just when `payload` changes), so JxtOffCanvas's own `portalContent`/`content`
  // memos - keyed on this object - recompute on every unrelated re-render of the host too.
  return useMemo(
    () => ({
      header: { title: t<string>('provide-a-status') },
      onHide: close,
      bodyClass: 'overflow-y-auto',
      children: payload && (
        <JxtWorkplaceCalendarContainer initialRange={payload.initialRange} onToastActionClicked={payload.onToastActionClicked} />
      ),
    }),
    [payload, close, t]
  );
};
